import '@popperjs/core';
import { TempusDominus } from '@eonasdan/tempus-dominus';
import { errorMessage } from "./errorMessage";

// Configurar el calendario con la libreria Tempus-Dominus
document.addEventListener('DOMContentLoaded', function () {
    const element = document.getElementById('datetimepicker1');
    if (element) {
        const calendar = new TempusDominus(element, {
            display: {
                viewMode: 'calendar',
                inline: true,
                components: {
                    decades: true,
                    year: true,
                    month: true,
                    date: true,
                    hours: false,
                    minutes: false,
                    seconds: false,
                },
            },
            localization: {
                locale: 'en',
                format: 'yyyy-MM-dd',
                hourCycle: 'h23',
            },
            multipleDates: true,        
        });
        console.log('Tempus Dominus initialized');
    } else {
        console.error('Element with id "datetimepicker1" not found');
    }
});


// Función para guardar los datos en sessionStorage
function saveData() {
    let date_not_format; // Declare outside the try block
    try {
        date_not_format = document.querySelector('#datetimepicker1 input').value || calendar.dates.lastPicked.format('YYYY-MM-DD');
    } catch (error) {
        return alert("No Dates");
    }
    const dateArray = date_not_format.split(";").map(date => date.trim()); 
    const date = `{${dateArray.join(",")}}`;
    const startTime = document.getElementById('startTime').value;
    const endTime = document.getElementById('endTime').value;
    const pickupCity = document.getElementById('pickupCity').value;
    const pickupSite = document.getElementById('pickupSite').value;

    let selectedFirstDayString = dateArray[0];
    let selectedFirstDay = new Date(selectedFirstDayString);
    let todayNow = new Date();
    selectedFirstDay.setHours(0, 0, 0, 0);
    todayNow.setHours(0, 0 , 0, 0);

    if (selectedFirstDay < todayNow) return errorMessage("Past dates are not allowed.");
    if (!startTime) return errorMessage("No Start Time");
    if (!pickupCity) return errorMessage("No City");
    if (!pickupSite) return errorMessage("No Pickup Site");
    
    sessionStorage.setItem('date', date);
    sessionStorage.setItem('startTime', startTime);
    sessionStorage.setItem('endTime', endTime);
    sessionStorage.setItem('pickupCity', pickupCity);
    sessionStorage.setItem('pickupSite', pickupSite);
    return(true);
}
        
// Agregar evento al botón Next
document.querySelector('a.btn-success').addEventListener('click', function(event) {
    event.preventDefault(); // Prevenir la navegación por defecto
    if(saveData() === true){
        window.location.href = 'form.html'; // Redirigir a la página de formulario
    } // Guardar los datos
});